// Los datos de contacto de la empresa sobre TanStack Query. Mismo patrón que
// `usePerfiles`: la cache de la query es la fuente de verdad y la mutación
// invalida su key en vez de parchear el objeto a mano.

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
  fetchDatosEmpresa,
  guardarDatosEmpresaRequest,
  type DatosEmpresaInput,
} from "@/lib/empresa";

export const DATOS_EMPRESA_KEY = ["datos-empresa"] as const;

export function useDatosEmpresa() {
  return useQuery({
    queryKey: DATOS_EMPRESA_KEY,
    queryFn: fetchDatosEmpresa,
  });
}

export function useGuardarDatosEmpresa() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: DatosEmpresaInput) => guardarDatosEmpresaRequest(input),
    // Se invalida en vez de escribir la respuesta en la cache: el servidor
    // devuelve además la comuna, la región y su abreviatura resueltas contra el
    // maestro, y volver a pedirlas es lo que garantiza que la pantalla muestre
    // lo que quedó guardado y no lo que se tipeó.
    onSuccess: () => queryClient.invalidateQueries({ queryKey: DATOS_EMPRESA_KEY }),
  });
}
